import { PlainSideSlider } from 'app/common/ui-next/plain-side-slider'
import { Header } from 'app/common/templates-next/page-template'
import { PlainDateSwitcherDouble } from 'app/common/ui-next/plain-date-switcher'
import { PlainDatePickerDouble } from 'app/common/ui-next/plain-date-picker'
import { PlainColumns } from 'app/common/ui/PlainGrid'
import { useCurrencySign } from 'app/common/components-next/currency'
import { useEffect, useState } from 'react'
import moment from 'moment'
import styles from './CompensationHistory.scss'
import { HistoryLoading } from './HistoryLoading'
import { CompensationHistoryTable } from './historyTable/CompensationHistoryTable'


type Props = {
  onCrossClick: () => void
  studentID: string
  supplierID: string | null
}
const periodFormat = 'YYYY-MM-DD'

const position = {
  top: 0,
  right: 0,
  bottom: 0,
}

export const CompensationHistory = ({ onCrossClick, studentID, supplierID }: Props) => {
  const [dateFrom, setDateFrom] = useState<string | null>(null)
  const [dateTo, setDateTo] = useState<string | null>(null)

  const currency = useCurrencySign()

  const onChangeDate = (from: string | null, to: string | null) => {
    setDateFrom(from)
    setDateTo(to)
  }

  useEffect(() => {
    const currentDate = moment()
    let currentYear = moment().year()

    const september1ThisYear = moment(`${currentYear}-09-01`, 'YYYY-MM-DD')
    if (currentDate.isBefore(september1ThisYear, 'day')) {
      currentYear -= 1
    }
    const defaultDateFrom = moment(`${currentYear}-09-01`, 'YYYY-MM-DD').format('YYYY-MM-DD')
    const currentDateTo = currentDate.format('YYYY-MM-DD')
    setDateFrom(defaultDateFrom)
    setDateTo(currentDateTo)
  }, [])

  if (!supplierID) {
    return <HistoryLoading />
  }

  return (
    <PlainSideSlider
      open
      onCrossClick={onCrossClick}
      position={position}
      className={styles.container}
    >

      <PlainColumns className={styles.row}>
        <Header className={styles.header}>{'История операций'}</Header>
        {dateFrom
          && dateTo
          && <PlainDateSwitcherDouble
            dateFrom={dateFrom}
            dateTo={dateTo}
            dateFormat={periodFormat}
            onDateChange={onChangeDate}
          >
            <PlainDatePickerDouble
              dateFrom={dateFrom}
              dateTo={dateTo}
              dateFormat={periodFormat}
              closeOnClick={false}
              onChange={onChangeDate}
            />
          </PlainDateSwitcherDouble>}
      </PlainColumns>

      {dateFrom
        && dateTo
        && <div style={{ display: 'flex', flex: 1, position: 'relative' }}>
          <CompensationHistoryTable
            studentID={studentID}
            supplierID={supplierID}
            periodFrom={dateFrom}
            periodTo={dateTo}
            periodFormat={periodFormat}
            currency={currency}
          />
        </div>}
    </PlainSideSlider>
  )
}
